import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

import {
  mensagensIniciais,
  aplicarIdioma,
  registrarI18n,
} from 'dashboard/i18n/lazy';
import * as Sentry from '@sentry/vue';
import {
  initializeAnalyticsEvents,
  initializeChatwootEvents,
} from 'dashboard/helper/scriptHelpers';
import App from '../v3/App.vue';
import router, { initalizeRouter } from '../v3/views/index';
import store from '../v3/store';
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon.vue';
// import { emitter } from '../shared/helpers/mitt';

// [VITE] This was added in https://github.com/chatwoot/chatwoot/commit/b57063a8b83c86819bd285f481298d7cd38ad50e
// Commenting it out for Vite migration
// Vue.config.env = process.env;

// Só o inglês (fallback) vem embutido; o idioma do usuário desce sozinho antes de
// montar a aplicação. Importar os 43 de uma vez punha 18 MB de traduções no bundle
// para o usuário usar UM. Ver dashboard/i18n/lazy.js.
const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  fallbackLocale: 'en',
  messages: mensagensIniciais,
});

registrarI18n(i18n);

const app = createApp(App);
app.use(i18n);
app.use(store);
app.use(router);

// Vue.use(VueRouter);
// Vue.use(VueI18n);
// Vue.prototype.$emitter = emitter;
app.component('fluent-icon', FluentIcon);

if (window.errorLoggingConfig) {
  Sentry.init({
    app,
    dsn: window.errorLoggingConfig,
    denyUrls: [
      // Chrome extensions
      /^chrome:\/\//i,
      /chrome-extension:/i,
      /extensions\//i,

      // Locally saved copies
      /file:\/\//i,

      // Safari extensions.
      /safari-web-extension:/i,
      /safari-extension:/i,
    ],
    integrations: [Sentry.browserTracingIntegration({ router })],
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });
}

initializeChatwootEvents();
initializeAnalyticsEvents();
initalizeRouter();

window.onload = async () => {
  // Espera só o idioma escolhido (arquivo pequeno) antes de montar: evita a tela
  // nascer em inglês e trocar depois. Falhou? monta em inglês e segue.
  await aplicarIdioma(window.chatwootConfig?.selectedLocale).catch(() => {});
  app.mount('#app');
};
